import {Component} from '@angular/core';
import {ComponentHelper, FormBaseComponent, ValidationPattern, ValidatorService} from '@utils-lib';
import {AppNameEnum, GruendungsartEnumLabels, GruendungsformAngaben, PersonenTypEnumLabels} from '@nachdigal';
import {FormBuilder} from '@angular/forms';
import {DatevMessageService} from '@datev/ngx-ui-components';
import {TranslateService} from '@ngx-translate/core';
import {ActivatedRoute} from '@angular/router';

@Component({
  selector: 'common-ui-gruendungsform',
  templateUrl: './gruendungsform.component.html'
})
export class GruendungsformComponent extends FormBaseComponent<GruendungsformAngaben> {

  public gruendungsartEnum = GruendungsartEnumLabels;
  public vorherigesUnternehmenTypEnum = PersonenTypEnumLabels;
  private appEnum: AppNameEnum;
  private cachedWirtschaftsIdNummer: string | null = null;

  constructor(private readonly formBuilder: FormBuilder,
              private readonly validatorService: ValidatorService,
              protected readonly messageService: DatevMessageService,
              protected readonly translateService: TranslateService,
              private readonly activatedRoute: ActivatedRoute) {
    super(messageService);
    this.appEnum = ComponentHelper.getAppEnum(this.activatedRoute.snapshot);
  }

  public get showWirtschaftsIdNummer(): boolean {
    return !(this.appEnum === AppNameEnum.FragebogenEUn
      && this.data?.vorherigesUnternehmenTyp === PersonenTypEnumLabels.NatPers);
  }

  public get showGruendungsformHinweis(): boolean {
    return this.appEnum === AppNameEnum.FragebogenEUn;
  }

  public clearVorherigerUnternehmen($event: unknown): void {
    if ($event === PersonenTypEnumLabels.NatPers) {
      this.data.vorherigesUnternehmen = null;
      if (this.appEnum === AppNameEnum.FragebogenEUn) {
        this.cachedWirtschaftsIdNummer = this.data.vorherigesUnternehmenWirtschaftsIdNummer;
        this.form.get('vorherigesUnternehmenWirtschaftsIdNummer').setValue(null);
      }
    } else {
      this.data.vorherigerInhaber = null;
      if (this.appEnum === AppNameEnum.FragebogenEUn && this.cachedWirtschaftsIdNummer !== null) {
        this.form.get('vorherigesUnternehmenWirtschaftsIdNummer').setValue(this.cachedWirtschaftsIdNummer);
        this.cachedWirtschaftsIdNummer = null;
      }
    }
  }

  public clearGruendungsForm($event: unknown): void {
    if ($event === this.gruendungsartEnum._1) {
      this.data.vorherigesUnternehmen = null;
      this.data.vorherigerInhaber = null;
      this.data.vorherigesUnternehmenAdresse = null;
      this.data.vorherigesUnternehmenSteuernummer = null;
      this.data.vorherigesUnternehmenUstIdentifikationsnummer = null;
      this.data.vorherigesUnternehmenWirtschaftsIdNummer = null;
      this.cachedWirtschaftsIdNummer = null;
    }
  }

  protected createForm(): void {
    this.form = this.formBuilder.group({
      gruendungsart: [this.data.gruendungsart,
        [
          this.validatorService.required()
        ]],
      gruendungsdatum: [this.data.gruendungsdatum,
        [
          this.validatorService.required(),
          this.validatorService.date()
        ]],
      vorherigesUnternehmenTyp: [this.data.vorherigesUnternehmenTyp, [
        this.validatorService.required()
      ]],
      vorherigesUnternehmenUstIdentifikationsnummer: [
        this.data.vorherigesUnternehmenUstIdentifikationsnummer, [
          this.validatorService.pattern(ValidationPattern.UST_ID,
            this.translateService.instant('COMMON_UI.VALIDATION.USTID_PATTERN'))
        ]],
      vorherigesUnternehmenWirtschaftsIdNummer: [
        this.data.vorherigesUnternehmenWirtschaftsIdNummer, [
          this.validatorService.pattern(ValidationPattern.WIRTSCHAFTS_ID,
            this.translateService.instant('COMMON_UI.VALIDATION.WIRTSCHAFTS_ID_NUMMER_INVALID_PATTERN'))
        ]]
    });
  }
}
